import React from 'react';
import './ToggleButton.scss';
import Atoms from '../../Atoms';

const ToggleButton = (props) => {
    const containerClassName = 'switch-toggle-wrapper ' + (props.className ? props.className : '');
    const inputClassName = (props.inputClassName ? props.inputClassName : '');
    const labelClassName = (props.labelClassName ? props.labelClassName : '');
    const inputName = (props.inputName ? props.inputName : '');
    const labelName = (props.labelName ? props.labelName : '');
    return (
        <div className = {containerClassName} >
            <Atoms.Input
                className = {inputClassName}
                id = {props.childId}
                type = 'checkbox'
                name = {inputName}
                togglerState = {props.togglerState}
                toggleClicked = {(e)=>{props.toggleClicked(e)}}
            />
            <Atoms.Label
                className = {labelClassName}
                htmlFor = {props.childId}
                name = {labelName}
                value = {props.labelValue}
            />
        </div>
    );
}

export default ToggleButton;